import { research, token, report, calendar, chart } from "../assets/icons"

export enum ContentEnum {
  ARTICLES_EN = 'article-en',
  ARTICLES_FR = 'article',
  REPORTS = 'reports',
  EVENTS = 'event',
  CHARTS = 'charts',
  TOKEN_SUMMARY = 'token-summary'
}

export interface ContentOptions {
  name: string
  icon: string
  // how many do we load for the last/default search
  limit: number
  sort: string
  hasDate: boolean
  isIcon: boolean
}

export const defaultOptions: Partial<ContentOptions> = {
  sort: 'createdOn:desc',
  hasDate: true,
  isIcon: false
}

const contentOptions = new Map<ContentEnum, Partial<ContentOptions>>([
  [ContentEnum.ARTICLES_EN, { icon: research, limit: 1 }],
  [ContentEnum.ARTICLES_FR, { icon: research, limit: 1 }],
  [ContentEnum.TOKEN_SUMMARY, { icon: token, hasDate: false, limit: 5, sort: 'rank:asc', isIcon: true }],
  [ContentEnum.REPORTS, { icon: report, limit: 1 }],
  [ContentEnum.EVENTS, { icon: calendar, hasDate: false, limit: 1 }],
  [ContentEnum.CHARTS, { icon: chart, hasDate: false, limit: 1, isIcon: true }],
])

export const getOptions = (contentType: ContentEnum | string) => {
  return Object({ ...defaultOptions, ...contentOptions.get(contentType as ContentEnum) }) as ContentOptions
}

export const getIcon = (contentType: ContentEnum | string) => getOptions(contentType).name

export const getIndexes = () => Object.keys(ContentEnum).map(k => ContentEnum[k])